import BottomNavigation from "components/BottomNavigation"
import BreadcrumbTitle from "components/BreadcrumbTitle"
import PageMetaTags from "components/PageMetaTags"
import { FORM_NAMES } from "constants/index"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import {
  Card,
  CardBody,
  Col,
  Container,
  Modal,
  Nav,
  NavLink,
  Row,
  Spinner,
  TabContent,
  TabPane,
} from "reactstrap"
import { FormSection, getFormValues, initialize, reduxForm } from "redux-form"
import {
  getIcons,
  getListScreenSetup,
  getPlatformSettings,
  getSocialProfileSettings,
  getVendorConfig,
  getWebsiteConfigs,
  updatePlatformSettings,
} from "store/actions"
import { getFileBlob, isHarvardClient, isIfoClient } from "utils"
import DesignTab from "./designTab"
import FeaturesTab from "./featuresTab"
import PaymentTab from "./paymentTab"
import { SOCIAL_FORM_FIELDS, mapApiResponseToForm, mapFormToApi } from "./utils"
import SocialProfileSetupTab from "./socialProfileSetupTab"
import WebsiteBranding from "./websiteBranding"
import DmAccessControls from "./dmAccessControls"

const PlatformSettings = ({
  loading,
  platformSettings,
  getPlatformSettings,
  vendorId,
  initializeForm,
  updatePlatformSettings,
  formValues,
  userId,
  getIcons,
  getListScreenSetup,
  vendorConfig,
  getVendorConfig,
  socialProfileSettings,
  getSocialProfileSettings,
  getWebsiteConfigs,
  websiteConfigs,
  handleSubmit,
}) => {
  const TABS = {
    DESIGN: 1,
    FEATURES: 2,
    PAYMENT: 3,
    SOCIAL_PROFILE: 4,
    WEBSITE_BRANDING: 5,
    DM_ACCESS_CONTROLS: 6,
  }
  const [activeTab, setActiveTab] = useState(TABS.DESIGN)

  const markIfIsActive = tab => {
    return activeTab === tab ? "active" : ""
  }

  useEffect(() => {
    if (vendorId) {
      getPlatformSettings({ vendorId })
      getIcons()
      getListScreenSetup({ vendorId })
      getVendorConfig({ id: vendorId })
      getSocialProfileSettings({ vendorId })
      if (isIfoClient() || isHarvardClient()) {
        getWebsiteConfigs({})
      }
    }
  }, [vendorId])

  const [initialized, setInitialized] = useState(false)

  useEffect(() => {
    if (platformSettings && socialProfileSettings && !initialized) {
      const forms = SOCIAL_FORM_FIELDS.filter(
        field =>
          field.vendors.length === 0 ||
          field.vendors.includes(parseInt(socialProfileSettings?.vendor_id))
      )?.map(x => ({ ...x }))

      const initialForms = socialProfileSettings?.fields_to_display

      for (let i = 0; i < forms?.length; i++) {
        const currentField = initialForms?.find(x => x?.key === forms[i]?.name)
        if (currentField) {
          forms[i].checked = true
          forms[i].required = socialProfileSettings?.required_fields?.includes(
            currentField?.key
          )
        } else {
          forms[i].checked = false
        }
      }

      initializeForm(
        mapApiResponseToForm(platformSettings, forms, websiteConfigs)
      )
      setInitialized(true)
    }
  }, [platformSettings, socialProfileSettings, websiteConfigs])

  const handleSave = () => {
    setInitialized(false)
    updatePlatformSettings({
      values: {
        ...platformSettings,
        ...mapFormToApi(formValues),
      },
      uploadBgImage: formValues?.design?.deleteBgImage,
      bgImage: {
        vendor_id: vendorId,
        dir: "background",
        user_id: userId,
        files: [
          getFileBlob(
            formValues?.design &&
              formValues?.design?.bgImage &&
              formValues?.design?.bgImage?.editedImage
          ),
        ],
      },
      uploadThumbnailImage: formValues?.design?.deleteThumbnailImage,
      thumbnailImage: {
        vendor_id: vendorId,
        dir: "background",
        user_id: userId,
        files: [
          getFileBlob(
            formValues?.design &&
              formValues?.design?.thumbnailImage &&
              formValues?.design?.thumbnailImage?.editedImage
          ),
        ],
      },
      uploadBrandImage: formValues?.design?.deleteBrandImage,
      brandImage: {
        vendor_id: vendorId,
        dir: "background",
        user_id: userId,
        files: [
          getFileBlob(
            formValues?.design &&
              formValues?.design?.brandImage &&
              formValues?.design?.brandImage?.editedImage
          ),
        ],
      },
    })
  }

  const [breadcrumbItems, setBreadcrumbItems] = useState([])

  useEffect(() => {
    let currentTab = ""
    switch (activeTab) {
      case 2:
        currentTab = "Features"
        break
      case 3:
        currentTab = "Payment Processing"
        break
      case 4:
        currentTab = "Social Profile Settings"
        break
      case 5:
        currentTab = "Website Branding"
        break
      case 6:
        currentTab = "Mobile Messages Settings"
        break
    }
    if (activeTab !== 1) {
      setBreadcrumbItems([
        { title: "Dashboard" },
        {
          title: "Platform Settings",
          type: "tab",
          clickHandler: () => setActiveTab(TABS.DESIGN),
        },
        { title: currentTab },
      ])
    }
  }, [activeTab])

  const setSubTabBreadcrumb = (tabTitle, clickHandler) => {
    setBreadcrumbItems([
      { title: "Dashboard" },
      { title: "Platform Settings", link: "/platform-settings" },
      {
        title: "Design",
        type: "tab",
        clickHandler: clickHandler,
      },
      { title: tabTitle },
    ])
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <PageMetaTags title="Platform Settings" />
        <Container fluid>
          <BreadcrumbTitle
            title="Platform Settings"
            breadcrumbItems={breadcrumbItems}
          />
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <Nav pills tabs>
                    <NavLink
                      className={markIfIsActive(TABS.DESIGN)}
                      onClick={() => setActiveTab(TABS.DESIGN)}
                    >
                      <span style={{ fontSize: "16px" }}>Default Design</span>
                    </NavLink>
                    <NavLink
                      className={markIfIsActive(TABS.FEATURES)}
                      onClick={() => setActiveTab(TABS.FEATURES)}
                    >
                      <span style={{ fontSize: "16px" }}>Default Features</span>
                    </NavLink>
                    {vendorConfig && vendorConfig?.ecommerce_enabled ? (
                      <NavLink
                        className={markIfIsActive(TABS.PAYMENT)}
                        onClick={() => setActiveTab(TABS.PAYMENT)}
                      >
                        <span style={{ fontSize: "16px" }}>
                          Payment Processing
                        </span>
                      </NavLink>
                    ) : (
                      <></>
                    )}
                    <NavLink
                      className={markIfIsActive(TABS.SOCIAL_PROFILE)}
                      onClick={() => setActiveTab(TABS.SOCIAL_PROFILE)}
                    >
                      <span style={{ fontSize: "16px" }}>
                        Social Profile Settings
                      </span>
                    </NavLink>
                    {(isIfoClient() || isHarvardClient()) && (
                      <NavLink
                        className={markIfIsActive(TABS.WEBSITE_BRANDING)}
                        onClick={() => setActiveTab(TABS.WEBSITE_BRANDING)}
                      >
                        <span style={{ fontSize: "16px" }}>
                          Website Branding
                        </span>
                      </NavLink>
                    )}
                    <NavLink
                      className={markIfIsActive(TABS.DM_ACCESS_CONTROLS)}
                      onClick={() => setActiveTab(TABS.DM_ACCESS_CONTROLS)}
                    >
                      <span style={{ fontSize: "16px" }}>
                        Mobile Messages Settings
                      </span>
                    </NavLink>
                  </Nav>
                  <TabContent activeTab={activeTab}>
                    <TabPane tabId={TABS.DESIGN}>
                      <FormSection name="design">
                        <DesignTab
                          tabIsActive={activeTab === TABS.DESIGN}
                          handleNext={() => setActiveTab(TABS.FEATURES)}
                          handleSave={handleSave}
                          setSubTabBreadcrumb={setSubTabBreadcrumb}
                        />
                      </FormSection>
                    </TabPane>
                    <TabPane tabId={TABS.FEATURES}>
                      <FormSection name="features">
                        <FeaturesTab
                          tabIsActive={activeTab === TABS.FEATURES}
                          handleSave={handleSave}
                          handleNext={() =>
                            setActiveTab(
                              vendorConfig && vendorConfig?.ecommerce_enabled
                                ? TABS.PAYMENT
                                : TABS.SOCIAL_PROFILE
                            )
                          }
                          handleBack={() => setActiveTab(TABS.DESIGN)}
                        />
                      </FormSection>
                    </TabPane>
                    {vendorConfig && vendorConfig?.ecommerce_enabled ? (
                      <TabPane tabId={TABS.PAYMENT}>
                        <PaymentTab />
                        <BottomNavigation
                          handleBack={() => setActiveTab(TABS.FEATURES)}
                          handleNext={() => setActiveTab(TABS.SOCIAL_PROFILE)}
                        />
                      </TabPane>
                    ) : (
                      <></>
                    )}
                    <TabPane tabId={TABS.SOCIAL_PROFILE}>
                      <FormSection name="socialProfile">
                        <SocialProfileSetupTab
                          handleBack={() => {
                            setActiveTab(
                              vendorConfig && vendorConfig?.ecommerce_enabled
                                ? TABS.PAYMENT
                                : TABS.FEATURES
                            )
                          }}
                          handleNext={
                            isIfoClient() || isHarvardClient()
                              ? () => {
                                  setActiveTab(TABS.WEBSITE_BRANDING)
                                }
                              : () => {
                                  setActiveTab(TABS.DM_ACCESS_CONTROLS)
                                }
                          }
                        />
                      </FormSection>
                    </TabPane>
                    {isIfoClient() || isHarvardClient() ? (
                      <TabPane tabId={TABS.WEBSITE_BRANDING}>
                        <FormSection name="websiteBranding">
                          <WebsiteBranding
                            handleBack={() => setActiveTab(TABS.SOCIAL_PROFILE)}
                            handleSubmit={handleSubmit}
                          />
                        </FormSection>
                      </TabPane>
                    ) : (
                      <></>
                    )}
                    <TabPane tabId={TABS.DM_ACCESS_CONTROLS}>
                      <DmAccessControls
                        handleBack={
                          isIfoClient() || isHarvardClient()
                            ? () => {
                                setActiveTab(TABS.WEBSITE_BRANDING)
                              }
                            : () => {
                                setActiveTab(TABS.SOCIAL_PROFILE)
                              }
                        }
                      />
                    </TabPane>
                  </TabContent>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal isOpen={loading} centered={true} size="sm">
        <CardBody className={"p-2 my-1 text-center"}>
          <Spinner className="ms-2" color="primary" />
        </CardBody>
      </Modal>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  vendorId: state.Login.vendorId,
  platformSettings: state.PlatformSettings.platformSettings,
  loading: state.PlatformSettings.loading,
  formValues: getFormValues(FORM_NAMES.PLATFORM_SETTINGS)(state),
  userId: state.Login.authUser.id,
  vendorConfig: state.clients.vendorConfig,
  socialProfileSettings: state.PlatformSettings.socialProfileSettings,
  websiteConfigs: state.PlatformSettings.websiteConfigs,
})

const mapDispatchToProps = dispatch => ({
  getPlatformSettings: values => dispatch(getPlatformSettings(values)),
  initializeForm: values =>
    dispatch(initialize(FORM_NAMES.PLATFORM_SETTINGS, values)),
  updatePlatformSettings: values => dispatch(updatePlatformSettings(values)),
  getIcons: () => dispatch(getIcons()),
  getListScreenSetup: values => dispatch(getListScreenSetup(values)),
  getVendorConfig: values => dispatch(getVendorConfig(values)),
  getSocialProfileSettings: values =>
    dispatch(getSocialProfileSettings(values)),
  getWebsiteConfigs: values => dispatch(getWebsiteConfigs(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({ form: FORM_NAMES.PLATFORM_SETTINGS })(PlatformSettings))
